import { Component, OnInit, Input } from '@angular/core';
import { IRegionComboData } from 'src/app/common-page-components/stores/filters-store/filters-store';

@Component({
  selector: 'app-table-members-search-item',
  templateUrl: './table-members-search-item.component.html',
  styleUrls: ['./table-members-search-item.component.scss']
})
export class TableMembersSearchItemComponent implements OnInit {

  @Input() continent: string;

  @Input() image: string;

  /**
   * Router link for redirect.
   *
   * @type {string[]}
   * @memberof TableMembersSearchItemComponent
   */
  @Input() routerLink : string[];

  /**
   * An input for check if continent is active from the parent.
   *
   * @type {boolean}
   * @memberof TableMembersSearchItemComponent
   */
  @Input()
  isActive:boolean;

  previousImage: string;
  constructor() { }

  ngOnInit() {
  }

  /**
   * Set continent active when mouse is over.
   *
   * @memberof TableMembersSearchItemComponent
   */
  onMouseOver() {
    this.image = this.getContinentAssetActive(this.continent, true);
  }

  /**
   * Set previous image that was set for continent when mouse is out.
   */
  onMouseOut() {
    this.image = this.getContinentAssetActive(this.continent, this.isActive);
  }

  /**
   * Get the active continent.
   *
   * @param {*} continent
   * @returns
   * @memberof TableMembersSearchItemComponent
   */
  getContinentAssetActive(continent, active:boolean) {
    const continentToSet = active ? `${continent.toLowerCase().toString()}-active` : continent.toLowerCase().toString();
    return '../../../../../../modules/custom/wa_angular/app/assets/images/assets-maps/'+continentToSet+'.png';
  }

}
